import { useEffect } from 'react'

// Set document.title from within a component.  Format: "{title} · Omnia Practice Management"
// so tab strips + Alt+Tab / Windows taskbar / Cmd+Tab all show the page name
// prefix — critical UX for users with multiple app windows open.
//
// Usage:
//   usePageTitle('Dashboard')                          → "Dashboard · Omnia Practice Management"
//   usePageTitle(`Matter — ${matter.title}`)           → "Matter — Smith v. Jones · Omnia Practice Management"
//   usePageTitle(null)                                 → resets to "Omnia Practice Management"
//
// Restores the previous title on unmount so a briefly-mounted popup can't
// leave a stale title behind on the underlying page.  Empty / null values
// fall back to the static app name.

const APP_NAME = 'Omnia Practice Management'

export default function usePageTitle (title) {
  useEffect(() => {
    const previous = document.title
    document.title = title ? `${title} · ${APP_NAME}` : APP_NAME
    return () => { document.title = previous }
  }, [title])
}
